import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { ellipsisMultiline } from '@/styles/helpers';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 40px 50px 50px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 20px;
  }
`;

export const Title = styled(Typography.Header).attrs({ $variant: '3' })`
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 22px;
    font-weight: 700;
  }
`;

export const CloseButton = styled(CloseIcon).attrs(({ theme }) => ({
  fill: theme.palette.secondary.labels,
}))`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const AdCard = styled(CustomLink)`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 15px 0;
  }
`;

export const AdImage = styled.img`
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
`;

export const AdInfo = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`;

export const AdPrice = styled(Typography.Header).attrs({ $variant: '0' })`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const AdTitle = styled(Typography.Body).attrs({ $variant: '4' })`
  color: ${({ theme }) => theme.palette.primary.labels};
  ${ellipsisMultiline(1)}
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const AdChevron = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
`;

export const Label = styled(Typography.Body)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)`
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.palette.primary.border};
`;

export const TotalLabel = styled(Typography.Body)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const TotalValue = styled(Typography.Body)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
